// extracted by mini-css-extract-plugin
export default {"Small":"style_Small__kEik4","Medium":"style_Medium__TIHS2","Large":"style_Large__u7j9E"};